import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

/** Le slug de l'organisation que le visiteur nomme, ou `null` (#346). Publique. */
export const GQL_FIND_ORGANIZATION = typedGql('query')({
  findOrganization: [{ query: $('query', 'String!') }, true],
})
